import request from '@/config/axios'

export interface FlipCoinConfigVO {
	odds: number
	minPrice: number
}

// 查询配置
export const getFlipCoinConfig = async () => {
	return await request.get<FlipCoinConfigVO>({ url: '/game/config/flipCoin/get' })
}